var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.busy,
          expression: "busy",
        },
      ],
    },
    [
      _c("div", { staticClass: "page-header d-flex align-items-center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-header-controls" },
          [
            _c("el-tooltip", { attrs: { content: "Generate Messages" } }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { disabled: !_vm.campaignsExist },
                  on: { click: _vm.confirmGenerating },
                },
                [_c("i", { staticClass: "fas fa-cloud-rain" })]
              ),
            ]),
            _vm._v(" "),
            _c("el-tooltip", { attrs: { content: "Schedule Sending" } }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { disabled: !_vm.canSchedule },
                  on: { click: _vm.confirmScheduling },
                },
                [_c("i", { staticClass: "fas fa-play" })]
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-4" }, [
          _c(
            "div",
            { staticClass: "border border-gray-500 campaign-list-container" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "auto-height",
                { staticClass: "campaign-list d-flex", attrs: { margin: 10 } },
                [
                  !_vm.campaignsExist
                    ? _c("placeholder-no-campaigns", {
                        staticClass: "text-secondary",
                        attrs: { url: _vm.campaignIndexLink },
                      })
                    : _c("campaign-list", {
                        staticClass: "flex-fill",
                        attrs: {
                          items: _vm.campaigns,
                          selected: _vm.selectedCampaign,
                        },
                        on: {
                          "update:selected": function ($event) {
                            _vm.selectedCampaign = $event
                          },
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-8" }, [
          _c(
            "div",
            { staticClass: "border border-gray-500 message-list-container" },
            [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "auto-height",
                { staticClass: "message-list d-flex", attrs: { margin: 10 } },
                [
                  !_vm.campaignsExist
                    ? _c("placeholder", { staticClass: "text-secondary" })
                    : !_vm.hasSelectedCampaign
                    ? _c("placeholder", {
                        staticClass: "text-secondary",
                        attrs: {
                          message: "Select a campaign to view messages",
                        },
                      })
                    : _c("message-list", {
                        key: _vm.messageListKey,
                        ref: "messageList",
                        attrs: { campaign: _vm.selectedCampaign },
                        on: {
                          "cached-preview-checked": _vm.onCachedPreviewChecked,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "not-generated",
                            fn: function () {
                              return [
                                _c("placeholder-messages-not-generated", {
                                  staticClass: "text-secondary",
                                  on: { generate: _vm.confirmGenerating },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("dialog-contact-form-wrapper"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-title flex-grow-1" }, [
      _c("h1", [_vm._v("CAMPAIGN SCHEDULING")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "py-2 bg-gray-500 text-center header" }, [
      _c("h6", { staticClass: "mb-0" }, [_vm._v("CAMPAIGNS")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "py-2 bg-gray-500 text-center header" }, [
      _c("h6", { staticClass: "mb-0" }, [_vm._v("MESSAGES")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }